import CrudTable from "../../../crud/CrudTable"
import {countryService as service} from "../../../../services"

const initFilter =  {
    name : null,
    code: null,
};


export default function Country() {

  const createEstructureFilter =  [
     {
       type:"input",
       name: "name",
       col: 4
      },
  ];


  return (
    <CrudTable
          service={service}
          urledit={"/country/edit/"}
          urlnew={"/country/new/"}
          filter={{...initFilter}}
          i18n={"country"}
          fieldstable={["name","nativeName","capital","emoji"]}
          estructureForm={createEstructureFilter} />
  );
}

